module.exports = __webpack_public_path__ + "static/media/visa.4f387f77.svg";